(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryDialogController', SubcategoryDialogController);

    SubcategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Subcategory'];

    function SubcategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Subcategory) {
        var vm = this;
        vm.subcategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:subcategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.subcategory.id !== null) {
                Subcategory.update(vm.subcategory, onSaveSuccess, onSaveError);
            } else {
                Subcategory.save(vm.subcategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.updatedAt = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
